export default __webpack_public_path__ + "static/media/pastIntro.7ff51282.jpg";